import { render } from "./Cookbook.vue?vue&type=template&id=416dd7ac"
import script from "./Cookbook.vue?vue&type=script&lang=js"
export * from "./Cookbook.vue?vue&type=script&lang=js"

import "./Cookbook.vue?vue&type=style&index=0&id=416dd7ac&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__